import React, { useMemo } from 'react';
import { Modal, View } from 'react-native';

import { useThemedStyles } from '../../hooks/useThemedStyles';
import Text from '../../components/text/Text';
import { PrimaryButton } from '../../design/components';
import { createClockPassViewStyles } from './ClockPassView.styles';
import {
	CLOCK_PASS_COPY,
	getShiftSummaryDurationLabel,
	getShiftSummaryTimeLabel,
} from './clockPassHelpers';

// Shown after a clock-out scan with the worked time and the shift's clock-in/out times.
const ShiftSummaryModal = ({ visible, shiftSummary, onClose }) => {
	const styles = useThemedStyles(createClockPassViewStyles);
	const shiftSummaryClockInLabel = useMemo(() => {
		return getShiftSummaryTimeLabel(shiftSummary?.clockInAt);
	}, [shiftSummary?.clockInAt]);
	const shiftSummaryClockOutLabel = useMemo(() => {
		return getShiftSummaryTimeLabel(shiftSummary?.clockOutAt);
	}, [shiftSummary?.clockOutAt]);
	const shiftSummaryDurationLabel = useMemo(() => {
		return getShiftSummaryDurationLabel(shiftSummary?.workedMinutes);
	}, [shiftSummary?.workedMinutes]);
	const hasShiftSummaryClockIn = Boolean(shiftSummary?.clockInAt);

	return (
		<Modal
			visible={visible}
			animationType="fade"
			transparent={true}
			statusBarTranslucent={true}
			onRequestClose={onClose}
		>
			<View style={styles.shiftSummaryModalRoot}>
				<View style={styles.shiftSummaryCard}>
					<Text style={styles.shiftSummaryTitle} accessibilityRole="header">{CLOCK_PASS_COPY.SHIFT_SUMMARY_TITLE}</Text>
					<View style={styles.shiftSummaryDurationCard}>
						<Text style={styles.shiftSummaryDurationLabel}>{CLOCK_PASS_COPY.SHIFT_SUMMARY_DURATION_LABEL}</Text>
						<Text style={styles.shiftSummaryDurationValue}>{shiftSummaryDurationLabel}</Text>
					</View>
					<View style={styles.shiftSummaryRow}>
						<Text style={styles.shiftSummaryRowLabel}>{CLOCK_PASS_COPY.SHIFT_SUMMARY_CLOCK_IN_LABEL}</Text>
						<Text style={styles.shiftSummaryRowValue}>{shiftSummaryClockInLabel}</Text>
					</View>
					<View style={styles.shiftSummaryRow}>
						<Text style={styles.shiftSummaryRowLabel}>{CLOCK_PASS_COPY.SHIFT_SUMMARY_CLOCK_OUT_LABEL}</Text>
						<Text style={styles.shiftSummaryRowValue}>{shiftSummaryClockOutLabel}</Text>
					</View>
					{!hasShiftSummaryClockIn ? (
						<Text style={styles.shiftSummaryHint}>{CLOCK_PASS_COPY.SHIFT_SUMMARY_HINT_NO_CLOCK_IN}</Text>
					) : null}
					<PrimaryButton
						label={CLOCK_PASS_COPY.SHIFT_SUMMARY_CLOSE_BUTTON}
						onPress={onClose}
					/>
				</View>
			</View>
		</Modal>
	);
};

export default ShiftSummaryModal;
